import BaseComponent from '../../BaseComponent';
import { ClassNames } from '../../../utils/dom/css-classes';
import SelectorEngine from '../../../utils/dom/selector-engine';

const NAME = 'BottomBackButton';

export default class BottomBackButton extends BaseComponent {
	static get NAME() {
		return NAME;
	}

	constructor(element, config) {
		super(element);
		if (this._element) {
			this.classPrefix = config.classPrefix;
			this.buttonLabel = config.backStepButtonLabel || 'Back';
			this.buttonClasses = config.backStepButtonClasses || '';
		}
	}

	markup() {
		return `
			<div class="u-flex u-align-center" style="flex-direction:row">				
				<button class="${this.classPrefix}__form-back-step-button lta-btn lta-btn--default lta-btn--line lta-btn--block u-mt-3 ${this.buttonClasses}" aria-label="back-step">
					${this.buttonLabel}
				</button>				
		  	</div>
		`;
	}

	show() {
		const bottomBackButton = SelectorEngine.findOne(`.${this.classPrefix}__form-back-step-button`, this._element);
		bottomBackButton?.classList?.remove(ClassNames.Hidden);
	}

	hide() {
		const bottomBackButton = SelectorEngine.findOne(`.${this.classPrefix}__form-back-step-button`, this._element);
		bottomBackButton?.classList?.add(ClassNames.Hidden);
	}
}
